import {
    AttributesEntityType,
    type ReportBuilderAttributeRuntimeDataQueryVariables,
} from '@/graphql/types';
import type { ContextForKind, RenderContextKind } from '../../../elements/types';

export function resolveAttributeRuntimeQueryVariables(
    contextKind: RenderContextKind,
    renderContext: ContextForKind<RenderContextKind>
): ReportBuilderAttributeRuntimeDataQueryVariables {
    if (renderContext.kind !== contextKind) {
        throw new Error(
            `Attribute runtime context mismatch: expected "${contextKind}", received "${renderContext.kind}".`
        );
    }

    if (renderContext.kind === 'project') {
        return {
            entityType: AttributesEntityType.Project,
            entityId: renderContext.project.id,
        };
    }

    return {
        entityType: AttributesEntityType.MeasuringPoint,
        entityId: renderContext.measuringPoint.id,
    };
}
